import { create } from 'zustand';

interface ExternalPointData {
  code: string;
  name: string;
  headerImageUrl: string | null;
}

interface ExternalPointState {
  activePoint: ExternalPointData | null;
  /** 현재 API 조회 중인 ref 코드. null이면 조회 완료 또는 ref 없음 */
  resolvingRefCode: string | null;
  setActivePoint: (point: ExternalPointData) => void;
  clearActivePoint: () => void;
  beginResolving: (code: string) => void;
  clearResolving: () => void;
}

// 앱 최초 로드 시 URL에서 ref를 동기적으로 읽어 초기값으로 설정
// — React 렌더 전에 실행되므로 첫 렌더부터 올바른 pending 상태를 가짐
const _initialResolvingCode =
  typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('ref') : null;

export const useExternalPointStore = create<ExternalPointState>()((set) => ({
  activePoint: null,
  resolvingRefCode: _initialResolvingCode,
  setActivePoint: (point) => set({ activePoint: point, resolvingRefCode: null }),
  clearActivePoint: () => set({ activePoint: null, resolvingRefCode: null }),
  beginResolving: (code) => set({ resolvingRefCode: code }),
  clearResolving: () => set({ resolvingRefCode: null }),
}));
